import { render } from "./MyNotifications.vue?vue&type=template&id=8e129ef0&scoped=true&ts=true"
import script from "./MyNotifications.vue?vue&type=script&lang=ts"
export * from "./MyNotifications.vue?vue&type=script&lang=ts"

import "./MyNotifications.vue?vue&type=style&index=0&id=8e129ef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e129ef0"]])

export default __exports__